<ng-container [ngSwitch]="context ? context.type : ''">
    <fui-edit-localisation-input #input (focussed$)="onFocussed($event)" *ngSwitchDefault></fui-edit-localisation-input>
    <fui-filter-localisation-input #input [label]="label" [localised]="localised" [(ngModel)]="value"
                                   (focussed$)="onFocussed($event)"
                                   *ngSwitchCase="contextType.FILTER"></fui-filter-localisation-input>
    <fui-inline-localisation-input #input (focussed$)="onFocussed($event)"
                                   *ngSwitchCase="contextType.INLINE"></fui-inline-localisation-input>
    <fui-localisation-pill (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.PILL"></fui-localisation-pill>
    <fui-pop-localisation-input #input (focussed$)="onFocussed($event)"
                                *ngSwitchCase="contextType.POP"></fui-pop-localisation-input>
</ng-container>
